import { useState, useEffect } from 'react';
import UKBankHolidays from '@hmcts/uk-bank-holidays';
import moment from 'moment';

export function useOutOfHours() {
  const [outOfHours, setOutOfHours] = useState(false);

  useEffect(() => {
    const now = moment();
    const isWeekend = now.format('d') == 0 || now.format('d') == 6;
    const isBetweenHours = now.format('HHmm') <= 800 || now.format('HHmm') >= 1830;
    const ukbankholidays = new UKBankHolidays(['england-and-wales']);

    ukbankholidays.load().then(() => {
      const isBankHoliday = ukbankholidays.isDateABankHoliday(now);

      if (isWeekend || isBetweenHours || isBankHoliday) {
        setOutOfHours(true);
        return;
      }

      setOutOfHours(false);
    });
  }, []);

  return outOfHours;
}
